export default [
    {
        date: 1581181530958,
        row: 10,
        col: 14,
        segments: [
            [7, 5, 7, 6],
            [8, 5, 7, 5],
            [7, 6, 8, 6],
            [7, 4, 7, 3],
            [7, 3, 8, 3],
            [8, 3, 8, 4],
            [8, 4, 7, 4],
            [8, 4, 8, 5],
            [9, 6, 9, 5],
            [10, 6, 9, 6],
            [9, 6, 8, 6],
            [7, 7, 7, 8],
            [7, 8, 8, 8],
            [8, 8, 8, 7],
            [8, 7, 7, 7],
            [7, 6, 7, 7],
            [6, 5, 5, 5],
            [5, 5, 5, 6],
            [5, 6, 6, 6],
            [6, 6, 6, 5],
            [7, 5, 6, 5],
            [8, 4, 11, 4],
            [11, 4, 11, 7],
            [9, 6, 9, 9],
            [11, 7, 9, 7],
            [9, 9, 6, 9],
            [6, 5, 6, 2],
            [6, 2, 9, 2],
            [9, 2, 9, 4],
            [7, 7, 4, 7],
            [6, 7, 6, 9],
            [4, 7, 4, 4],
            [4, 4, 6, 4],
            [9, 5, 9, 4],
            [10, 5, 11, 4],
            [10, 6, 11, 7],
            [8, 3, 9, 2],
            [7, 3, 6, 2],
            [7, 4, 6, 4],
            [7, 4, 6, 5],
            [7, 4, 7, 5],
            [7, 4, 8, 5],
            [8, 5, 9, 5],
            [8, 5, 9, 4],
            [8, 4, 9, 5],
            [8, 4, 9, 3],
            [9, 3, 8, 3],
            [8, 3, 9, 4],
            [9, 3, 8, 2],
            [8, 2, 8, 3],
            [8, 3, 7, 2],
            [7, 3, 8, 2],
            [7, 2, 7, 3],
            [6, 3, 7, 2],
            [6, 3, 7, 3],
            [6, 3, 7, 4],
            [6, 4, 7, 3],
            [8, 4, 7, 5],
            [6, 4, 7, 5],
            [9, 4, 10, 5],
            [9, 5, 10, 4],
            [10, 4, 10, 5],
            [11, 5, 10, 4],
            [10, 5, 11, 5],
            [10, 5, 11, 6],
            [10, 6, 11, 5],
            [10, 6, 11, 6],
            [10, 7, 11, 6],
            [10, 6, 10, 7],
            [10, 6, 9, 7],
            [9, 6, 10, 7],
            [9, 6, 8, 5],
            [8, 6, 9, 5],
            [8, 6, 9, 7],
            [8, 7, 9, 6],
            [8, 6, 8, 7],
            [8, 7, 9, 7],
            [8, 6, 7, 7],
            [7, 6, 8, 7],
            [7, 6, 8, 5],
            [8, 6, 8, 5],
            [7, 5, 8, 6],
            [6, 5, 7, 6],
            [6, 6, 7, 5],
            [6, 6, 7, 6],
            [6, 6, 6, 7],
            [6, 6, 7, 7],
            [6, 7, 7, 6],
            [7, 8, 6, 7],
            [6, 8, 7, 7],
            [7, 8, 6, 9],
            [6, 8, 7, 9],
            [6, 8, 7, 8],
            [7, 8, 7, 9],
            [8, 8, 7, 9],
            [7, 8, 8, 9],
            [8, 8, 8, 9],
            [8, 8, 9, 9],
            [8, 9, 9, 8],
            [8, 8, 9, 8],
            [9, 8, 8, 7],
            [8, 8, 9, 7],
            [6, 5, 5, 4],
            [5, 5, 6, 4],
            [5, 4, 5, 5],
            [5, 5, 4, 4],
            [4, 5, 5, 4],
            [4, 5, 5, 5],
            [5, 5, 4, 6],
            [5, 6, 4, 5],
            [4, 6, 5, 6],
            [5, 6, 5, 7],
            [5, 6, 4, 7],
            [4, 6, 5, 7],
            [5, 6, 6, 7],
            [5, 7, 6, 6],
            [10, 5, 9, 5],
            [10, 6, 10, 5],
            [9, 3, 10, 4],
            [10, 3, 9, 4],
            [10, 3, 11, 2],
            [11, 2, 12, 1],
            [12, 2, 11, 1],
            [11, 3, 10, 2],
            [10, 3, 10, 4],
            [10, 3, 9, 3],
            [10, 2, 10, 3],
            [10, 2, 11, 2],
            [11, 2, 11, 3],
            [10, 3, 11, 3],
            [11, 2, 12, 2],
            [11, 1, 12, 1],
            [12, 1, 12, 2],
            [12, 2, 11, 3],
            [11, 3, 10, 4],
            [9, 3, 10, 2],
            [10, 2, 11, 1],
            [11, 2, 11, 1],
            [9, 8, 9, 7],
            [9, 7, 10, 8],
            [11, 9, 10, 8],
            [11, 9, 12, 10],
            [12, 10, 12, 9],
            [12, 9, 11, 9],
            [11, 9, 11, 10],
            [12, 10, 11, 10],
            [11, 9, 11, 8],
            [11, 8, 10, 8],
            [10, 8, 10, 9],
            [10, 9, 11, 9],
            [10, 9, 11, 8],
            [11, 10, 12, 9],
            [10, 8, 10, 7],
            [9, 8, 10, 8],
            [10, 7, 9, 8],
            [9, 8, 10, 9],
            [10, 9, 11, 10],
            [12, 9, 11, 8],
            [11, 8, 10, 7],
            [6, 7, 5, 8],
            [5, 8, 4, 9],
            [4, 9, 3, 10],
            [3, 10, 3, 9],
            [3, 9, 4, 9],
            [4, 9, 4, 10],
            [4, 10, 3, 10],
            [3, 9, 4, 10],
            [4, 9, 5, 9],
            [5, 9, 5, 8],
            [5, 8, 4, 8],
            [4, 9, 4, 8],
            [4, 8, 5, 9],
            [5, 8, 5, 7],
            [5, 8, 6, 8],
            [6, 8, 5, 7],
            [6, 8, 5, 9],
            [5, 9, 4, 10],
            [3, 9, 4, 8],
            [4, 8, 5, 7],
            [5, 4, 5, 3],
            [6, 3, 5, 3],
            [5, 3, 6, 4],
            [5, 4, 6, 3],
            [5, 3, 4, 2],
            [4, 2, 5, 2],
            [5, 3, 4, 3],
            [4, 2, 4, 3],
            [5, 2, 5, 3],
            [5, 2, 4, 3],
            [4, 2, 4, 1],
            [3, 1, 3, 2],
            [4, 2, 3, 2],
            [4, 1, 3, 1],
            [3, 1, 4, 2],
            [4, 1, 3, 2],
            [4, 1, 5, 2],
            [5, 2, 6, 3],
            [5, 4, 4, 3],
            [4, 3, 3, 2],
            [11, 3, 11, 4],
            [10, 2, 9, 2],
            [6, 2, 5, 2],
            [4, 3, 4, 4],
            [5, 3, 4, 4],
            [5, 3, 6, 2],
            [9, 2, 10, 3],
            [10, 3, 11, 4],
            [11, 7, 11, 8],
            [11, 7, 10, 8],
            [9, 9, 10, 9],
            [10, 8, 9, 9],
            [6, 9, 5, 9],
            [6, 9, 5, 8],
            [4, 8, 4, 7],
            [5, 8, 4, 7],
        ],
    },
];
